{
  "header": {
    "powerTitle": "Power Zones",
    "heartRateTitle": "Heart Rate Zones",
    "powerDescription": "Configure {{count}} power zones based on FTP{{suffix}}",
    "heartRateDescription": "Configure {{count}} heart rate zones based on LTHR{{suffix}}",
    "ftpSuffix": " ({{ftp}}W)",
    "lthrSuffix": " ({{lthr}} bpm)"
  },
  "actions": {
    "cancel": "Cancel",
    "saveZones": "Save Zones"
  },
  "inputs": {
    "namePlaceholder": "Zone name",
    "minPercent": "Min %",
    "maxPercent": "Max %",
    "minBpm": "Min BPM",
    "maxBpm": "Max BPM"
  },
  "method": {
    "ariaLabel": "{{type}} zone method",
    "confirmTitle": "Change Zone Method",
    "confirmMessage": "This will replace your current zones with calculated values. Continue?",
    "confirmLabel": "Change Method",
    "keepLabel": "Keep Current"
  },
  "table": {
    "noZones": "No zones configured",
    "addZone": "+ Add Zone",
    "zoneNameAria": "{{prefix}} Zone {{zone}} name",
    "zoneMinAria": "{{prefix}} Zone {{zone}} min",
    "zoneMaxAria": "{{prefix}} Zone {{zone}} max",
    "removeZoneAria": "Remove {{prefix}} zone {{zone}}"
  },
  "tabs": {
    "cycling": "Cycling",
    "running": "Running",
    "swimming": "Swimming",
    "generic": "Generic"
  },
  "section": {
    "heartRate": "Heart Rate Zones",
    "power": "Power Zones",
    "pace": "Pace Zones"
  },
  "validation": {
    "heading": "Validation Errors",
    "zoneLabel": "Zone {{zone}}: {{message}}",
    "min-max": "Min must be less than max",
    "overlap": "Overlaps with next zone"
  },
  "zoneType": {
    "hr": "HR",
    "power": "Power",
    "pace": "Pace"
  },
  "empty": {
    "noSportConfig": "No zone configuration for this sport."
  },
  "zoneName": {
    "z1": "Recovery",
    "z2": "Endurance",
    "z3": "Tempo",
    "z4": "Threshold",
    "z5": "VO₂ Max"
  },
  "thresholdName": {
    "ftp": "FTP",
    "thresholdPace": "Threshold pace",
    "cssPace": "CSS pace"
  },
  "defaultName": {
    "recovery": "Recovery",
    "aerobic": "Aerobic",
    "tempo": "Tempo",
    "threshold": "Threshold",
    "vo2_max": "VO₂ Max",
    "extensive_endurance": "Extensive Endurance",
    "intensive_endurance": "Intensive Endurance",
    "aerobic_capacity": "Aerobic Capacity",
    "low_intensity": "Low Intensity",
    "high_intensity": "High Intensity",
    "endurance": "Endurance",
    "active_recovery": "Active Recovery",
    "foundation": "Foundation",
    "anaerobic": "Anaerobic",
    "anaerobic_capacity": "Anaerobic Capacity",
    "lactate_threshold": "Lactate Threshold",
    "neuromuscular": "Neuromuscular",
    "neuromuscular_power": "Neuromuscular Power",
    "subthreshold": "SubThreshold",
    "superthreshold": "SuperThreshold",
    "easy": "Easy",
    "zone_n": "Zone {{n}}"
  },
  "methodName": {
    "polarized-hr-3": "Polarized 3-zone",
    "karvonen-5": "Karvonen 5-zone",
    "friel-hr-5": "Friel 5-zone",
    "custom": "Custom",
    "polarized-3": "Polarized 3-zone",
    "classic-5": "Classic 5-zone",
    "british-cycling-6": "British Cycling 6-zone",
    "coggan-7": "Coggan 7-zone",
    "friel-7": "Friel 7-zone",
    "daniels-5": "Daniels 5-zone",
    "own": "Your own zones"
  },
  "status": {
    "saved": "Saved"
  },
  "toast": {
    "updateFailed": "Failed to update zones — please retry."
  }
}
